var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataBreach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58605 1.20928L3.94419 2.90149C2.87442 3.28854 2 4.51269 2 5.61083V12.2987C2 13.3608 2.72558 14.756 3.6093 15.395L7.6093 18.2844C8.92093 19.2385 11.0791 19.2385 12.3907 18.2844L16.3907 15.395C17.2744 14.756 18 13.3608 18 12.2987V5.61083C18 4.50369 17.1256 3.27953 16.0558 2.89249L11.414 1.20928C10.6233 0.930241 9.35814 0.930241 8.58605 1.20928Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 9.33323V8C7.66406 6.61667 8.08073 5.5 10.1641 5.5C12.2474 5.5 12.6641 6.16699 12.6641 7.16699",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.334H8.08333C6.41667 14.334 6 13.9173 6 12.2507V11.4173C6 9.75065 6.41667 9.33398 8.08333 9.33398H12.25C13.9167 9.33398 14.3333 9.75065 14.3333 11.4173V12.2507C14.3333 13.9173 13.9167 14.334 12.25 14.334Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBreach);
export default __webpack_public_path__ + "static/media/data-breach.a41b3408d8efae78d760644492b3c28d.svg";
export { ForwardRef as ReactComponent };